import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Layout from '../Layout/Layout';

export default function ServiceWorkerNotSupported() {
  return (
    <Layout plain>
      <h4 className="mt-5">
        <FontAwesomeIcon icon={faExclamationCircle} /> Error
      </h4>
      <p>Service worker not supported.</p>
      <p className="mt-5 small text-muted">
        <a href="/admin/">click here</a> to refresh the validation.
      </p>
    </Layout>
  );
}
